/** Ключ хранения выбранного языка (явный выбор в настройках). */
export const APP_LOCALE_STORAGE_KEY = 'duvpost.i18n.locale';

export const APP_LOCALES = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'ru', label: 'Русский' },
  { code: 'de', label: 'Deutsch' },
  { code: 'fr', label: 'Français' },
  { code: 'ja', label: '日本語' },
  { code: 'zh', label: '中文' },
] as const;

export type AppLocaleCode = (typeof APP_LOCALES)[number]['code'];

const SUPPORTED = new Set<string>(APP_LOCALES.map((l) => l.code));

export function normalizeToSupportedBase(tag: string): AppLocaleCode | null {
  const base = tag.toLowerCase().split(/[-_]/)[0];
  if (SUPPORTED.has(base)) return base as AppLocaleCode;
  return null;
}

/** Язык из настроек браузера, если он есть в приложении; иначе fallback. */
export function resolveLocaleFromBrowser(fallback: AppLocaleCode = 'en'): AppLocaleCode {
  if (typeof navigator === 'undefined') return fallback;
  const list = [...(navigator.languages ?? []), navigator.language];
  for (const raw of list) {
    const hit = normalizeToSupportedBase(raw);
    if (hit) return hit;
  }
  return fallback;
}

export function readStoredAppLocale(): AppLocaleCode | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(APP_LOCALE_STORAGE_KEY);
    if (!raw) return null;
    return normalizeToSupportedBase(raw);
  } catch {
    return null;
  }
}

export function writeStoredAppLocale(code: AppLocaleCode): void {
  try {
    localStorage.setItem(APP_LOCALE_STORAGE_KEY, code);
  } catch {
    /* private mode / запрет storage */
  }
}

/** Для первого запуска: только браузер. После выбора в настройках — значение из storage. */
export function getInitialAppLocale(): AppLocaleCode {
  return readStoredAppLocale() ?? resolveLocaleFromBrowser('en');
}
